export const sourceFeatureKey = 'source';

export type SourceModel = {
  id: number;
  name: string;
  endDate: Date | null;
  startDate: Date | null;
};
